const lockedCampaigns = [
  'OptInRequest',
  'BookingUpdated',
  'AlreadySubscribed'
]

export default lockedCampaigns
